// @flow

type Props = {|
    renderCustomArrows?: () => React$Node,
|};

export const DataTableScrollArrows: React$ComponentType<Props> = (props: Props) => {
    const {
        renderCustomArrows,
    } = props;

    if (renderCustomArrows) {
        return renderCustomArrows();
    }

    return null;
};
